import authService from "@/services/authService";

const delegationService = {

    isAdmin() {
        return this.hasAccess(authService.getAdminRoles());
    },

    isAdminReadOnly() {
        return this.hasAccess(authService.getAdminReadOnlyRoles());
    },

    isManagerFC() {
        return this.hasAccess(authService.getManagerRoles());
    },

    isAccountant() {
        return this.hasAccess(authService.getAccountantRoles());
    },

    isUniversityManager() {
        return this.hasAccess(authService.getUniversityManagerRoles());
    },

    isRector() {
        return this.hasAccess(authService.getUniversityRectorRoles());
    },

    isAudit() {
        return this.hasAccess(authService.getAuditRoles());
    },

    hasAccess(allRoles: string[]) {
        return authService.hasAccess(allRoles);
    }
}

export default delegationService;
